/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
import { AddressDetails__AddressFragmentDoc } from '../addresses/Addresses.generated.js';
import { ProjectListItemFragmentDoc } from '../projects/components/ProjectListItem.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PlanningMapResourceFragment = { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, phones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }>, roles: Array<{ __typename: 'OrganisationRole', id: string, label: string, internalName: string }>, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null };

export type PlanningMapProjectFragment = { __typename: 'Project', id: string, title: string, ticket: boolean, owningSystemOrganisationId: string, viewerPermissions: Array<Types.PermissionName>, deadline?: any | null, overdue: boolean, state: Types.ProjectStateMachineStatus, number: string, createdAt?: any | null, categories: Array<string>, type?: Types.ProjectType | null, leadId?: number | null, urgent: boolean, earliestStart?: any | null, earliestPlanSessionDate?: any | null, planned: boolean, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', streetLines1: string, city: string, postalCode: string, countryCode: string, id: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, phase: { __typename: 'OrganisationProjectPhase', id: string, name: string, applicableForState: Types.ProjectStateMachineStatus, color: string }, budget?: { __typename: 'Money', currency: string, amount: number } | null, plannedUsers: Array<{ __typename: 'User', id: string, firstname: string, familyname: string } | null>, assignee?: { __typename: 'ProjectMembership', id: string, user: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } | null, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, contactPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null } | null, crmLinks: Array<{ __typename: 'ProjectLinkCrmOrganisation', id: string, linkAs: string, crmOrganisation: { __typename: 'CrmCompany', id: string, title: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } | { __typename: 'ProjectLinkCrmUser', id: string, linkAs: string, crmUser: { __typename: 'CrmPerson', id: string, fullname: string, firstname: string, familyname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }>, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, crmCompany: { __typename: 'CrmCompany', id: string } } }>, source: { __typename: 'ProjectSource', id: string, source: Types.ProjectSourceType, importFileName?: string | null, manualPageName?: Types.ProjectSourcePageName | null, quoteProductsDistributionId?: string | null, requestId?: string | null, requestTitle?: string | null, flowTemplateId?: string | null, flowTemplateTitle?: string | null, flowTemplateVersionCounter?: number | null, flowCallId?: string | null } };

export type PlanningMapQueryVariables = Types.Exact<{
  center: Types.LocationInput;
  bounds: Types.BoundsInput;
  limit: Types.Scalars['Int']['input'];
}>;


export type PlanningMapQuery = { organisationMemberships: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'OrganisationMembershipsConnection', edges: Array<{ __typename: 'OrganisationMembershipEdge', node: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, email: any, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, phones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }>, roles: Array<{ __typename: 'OrganisationRole', id: string, label: string, internalName: string }>, homeAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } }> } };

export const PlanningMapResourceFragmentDoc = gql`
    fragment PlanningMapResource on User {
  id
  firstname
  familyname
  fullname
  avatar {
    ...AttachmentSnapshot
  }
  email
  phones {
    id
    number
    type
    main
  }
  roles {
    id
    label
    internalName
  }
  homeAddress {
    ...AddressDetails__Address
  }
}
    ${AttachmentSnapshotFragmentDoc}
${AddressDetails__AddressFragmentDoc}`;
export const PlanningMapProjectFragmentDoc = gql`
    fragment PlanningMapProject on Project {
  id
  title
  ticket
  owningSystemOrganisationId
  viewerPermissions
  buildingInfo {
    id
    title
    buildingAddress {
      ...AddressDetails__Address
    }
  }
  ...ProjectListItem
}
    ${AddressDetails__AddressFragmentDoc}
${ProjectListItemFragmentDoc}`;
export const PlanningMapDocument = gql`
    query PlanningMap($center: LocationInput!, $bounds: BoundsInput!, $limit: Int!) {
  organisationMemberships(
    offset: 0
    limit: $limit
    sorting: [{column: distanceFromHomeAddressToLocation, direction: asc}]
    filters: {statuses: [ACTIVATED], distanceFromHomeAddressToLocation: $center, hasHomeAddress: true, homeAddressWithinBounds: $bounds}
  ) {
    ... on OrganisationMembershipsConnection {
      edges {
        node {
          id
          ...PlanningMapResource
        }
      }
    }
  }
}
    ${PlanningMapResourceFragmentDoc}`;

/**
 * __usePlanningMapQuery__
 *
 * To run a query within a React component, call `usePlanningMapQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlanningMapQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlanningMapQuery({
 *   variables: {
 *      center: // value for 'center'
 *      bounds: // value for 'bounds'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePlanningMapQuery(baseOptions: Apollo.QueryHookOptions<PlanningMapQuery, PlanningMapQueryVariables> & ({ variables: PlanningMapQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlanningMapQuery, PlanningMapQueryVariables>(PlanningMapDocument, options);
      }
export function usePlanningMapLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlanningMapQuery, PlanningMapQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlanningMapQuery, PlanningMapQueryVariables>(PlanningMapDocument, options);
        }
export function usePlanningMapSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlanningMapQuery, PlanningMapQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlanningMapQuery, PlanningMapQueryVariables>(PlanningMapDocument, options);
        }
export type PlanningMapQueryHookResult = ReturnType<typeof usePlanningMapQuery>;
export type PlanningMapLazyQueryHookResult = ReturnType<typeof usePlanningMapLazyQuery>;
export type PlanningMapSuspenseQueryHookResult = ReturnType<typeof usePlanningMapSuspenseQuery>;
export type PlanningMapQueryResult = Apollo.QueryResult<PlanningMapQuery, PlanningMapQueryVariables>;